<div class="lv-sticky-header">
  <button mat-icon-button (click)="showNavigation = !showNavigation">
    <mat-icon [svgIcon]="'bars'"></mat-icon>
  </button>
  <button mat-icon-button (click)="showBeitrag = !showBeitrag">
    {{shrinkedLabel}}
    <mat-icon *ngIf="!showBeitrag" [svgIcon]="'long-arrow-down'" class="lv-icon-arrow"></mat-icon>
    <mat-icon *ngIf="showBeitrag" [svgIcon]="'long-arrow-up'" class="lv-icon-arrow"></mat-icon>
  </button>
</div>

<div *ngIf="showNavigation" class="lv-header-navigation" [@showNavigationAnimation] [class.lv-show-navigation]="showNavigation">
    <button class="lv-button-close" mat-icon-button (click)="showNavigation = false">
      <mat-icon [svgIcon]="'Times'"></mat-icon>
    </button>
    <lv-ui-spalte [uiVorgang]="uiVorgang"
                  [uiSpalte]="uiVorgangLayoutSpalte.SPALTE_LINKS"></lv-ui-spalte>
</div>

<div class="lv-header-beitrag" [class.lv-show-beitrag]="showBeitrag">
  <ng-container *ngIf="showBeitrag">
    <button class="lv-button-close" mat-icon-button (click)="showBeitrag = false">
      <mat-icon [svgIcon]="'Times'"></mat-icon>
    </button>
    <lv-ui-spalte [uiVorgang]="uiVorgang"
                  [uiSpalte]="uiVorgangLayoutSpalte.SPALTE_RECHTS"></lv-ui-spalte>
  </ng-container>
</div>
